function reportToClarity(entry, isFailure, hasFailures) {
    if (typeof window.clarity !== 'function') {
        return;
    }

    try {
        const clarityEventName = [
            'kd_analytics',
            entry.stage,
            entry.eventName,
        ].filter(Boolean).join('_').slice(0, 255);

        window.clarity('event', clarityEventName);

        if (entry.stage === 'gtm_loaded' && !hasFailures) {
            window.clarity('set', 'kd_analytics_health', 'ok');
        }

        if (isFailure) {
            window.clarity('set', 'kd_analytics_health', 'attention');
            window.clarity('set', 'kd_analytics_failure_stage', entry.stage);
            if (entry.eventName) {
                window.clarity('set', 'kd_analytics_failure_event', entry.eventName);
            }
            window.clarity('upgrade', 'kd_analytics_failure');
        }
    } catch (error) {
        // Clarity observability must never interfere with analytics delivery.
    }
}

module.exports = {
    reportToClarity,
};
